// extracted by mini-css-extract-plugin
export default {"openedRequestsModalBody":"openedRequestsModalBody---lxWZ_","openedRequestsModalItem":"openedRequestsModalItem---qL6OI"};